import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setInfiniteScrollMode } from "store/actions/queriesConfig";

export const useInfiniteScrollToggle = (): void => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setInfiniteScrollMode(false));

    return () => {
      dispatch(setInfiniteScrollMode(true));
    };
  }, []);
};
